import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const CheckDoubleIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M17.6443 6.33419L16.3101 5L10.311 10.9991L11.6452 12.3333L17.6443 6.33419ZM21.6563 5L11.6452 15.0112L7.68989 11.0654L6.3557 12.3996L11.6452 17.689L23 6.33419L21.6563 5ZM1 12.3996L6.28946 17.689L7.62366 16.3548L2.34366 11.0654L1 12.3996Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
